import { render, staticRenderFns } from "./TermsPopup.vue?vue&type=template&id=1c896d98&"
import script from "./TermsPopup.vue?vue&type=script&lang=js&"
export * from "./TermsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports